import asyncAppend from "@elements/async-append";
import {getPrefixedDataSet} from "@elements/data-set-utils";
import fetch from "@elements/fetch";

export function initInScope($scope) {
    $scope.find('.js-async-append-accordion').each(function () {
        let element = $(this);
        let dataset = getPrefixedDataSet('async-append-viewport', element);
        let target;

        target = element.find('.js-async-append-accordion__result');

        asyncAppend({
            $target: target,
            $loading: element.find('.js-async-append-accordion__loading'),
            $notifications: element.find('.js-async-append-accordion__notification')
        }, fetch( dataset.url,
            {
                method: 'GET',
                headers: {
                    'X-Requested-With' : 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                }
            }));
    });
}